package com.castly.admin.dto

import kotlinx.serialization.Serializable

/**
 * Standard error response format for public API endpoints
 * Following RESTful conventions with error code, message, and optional details
 *
 * Frontend copy (Kotlin/JS compatible)
 *
 * @property error Machine-readable error code (e.g., "INVALID_UUID", "NOT_FOUND")
 * @property message Human-readable error message
 * @property details Optional additional error context (e.g., field-level errors)
 */
@Serializable
data class ErrorResponse(
    val error: String,
    val message: String,
    val details: Map<String, String>? = null
)
